import { createSelector } from '@reduxjs/toolkit';
import { initialState } from '.';

export const selectMasterSlice = state => state.masterData || initialState;

export const selectManualVisible = createSelector(
  [selectMasterSlice],
  state => state.manualVisible,
);

export const selectManualType = createSelector(
  [selectMasterSlice],
  state => state.manualType,
);

export const selectMasterData = createSelector(
  [selectMasterSlice],
  state => state,
);

export const selectCountriesCodeList = createSelector(
  [selectMasterSlice],
  state => state.countriesCodeList,
);

export const selectCountriesCodeLastFetch = createSelector(
  [selectMasterSlice],
  state => state.countriesCodeLastFetch,
);

// export const selectRolesList = createSelector(
//   [selectMasterSlice],
//   state => state.rolesList,
// );

// export const selectRolesLastFetch = createSelector(
//   [selectMasterSlice],
//   state => state.rolesLastFetch,
// );

export const selectRolesList = level_type =>
  createSelector(
    [selectMasterSlice],
    state => state[`${level_type}RolesList`] || [],
  );

export const selectRolesLastFetch = level_type =>
  createSelector(
    [selectMasterSlice],
    state => state[`${level_type}RolesLastFetch`] || 0,
  );

export const selectStatesList = createSelector(
  [selectMasterSlice],
  state => state.statesList,
);

export const selectStatesLastFetch = createSelector(
  [selectMasterSlice],
  state => state.statesLastFetch,
);

export const selectConstituenciesList = createSelector(
  [selectMasterSlice],
  state => state.constituenciesList,
);

export const selectConstituenciesLastFetch = createSelector(
  [selectMasterSlice],
  state => state.constituenciesLastFetch,
);

export const selectLanguagesList = createSelector(
  [selectMasterSlice],
  state => state.languagesList,
);

export const selectLanguagesLastFetch = createSelector(
  [selectMasterSlice],
  state => state.languagesLastFetch,
);

export const selectDateFormatsList = createSelector(
  [selectMasterSlice],
  state => state.dateFormatsList,
);

export const selectDateFormatsLastFetch = createSelector(
  [selectMasterSlice],
  state => state.dateFormatsLastFetch,
);

export const selectCurrencyList = createSelector(
  [selectMasterSlice],
  state => state.currencyList,
);

export const selectCurrencyLastFetch = createSelector(
  [selectMasterSlice],
  state => state.currencyLastFetch,
);

export const selectDictionaryList = type =>
  createSelector([selectMasterSlice], state => state[`${type}DataList`] || []);

export const selectDictionaryLastFetch = type =>
  createSelector(
    [selectMasterSlice],
    state => state[`${type}DataLastFetch`] || 0,
  );

export const selectGenerateSubdomainState = createSelector(
  [selectMasterSlice],
  masterDataState => ({
    loading: masterDataState.generateDomainLoading,
    subdomain: masterDataState.generateDomainResult,
    error: masterDataState.generateDomainError,
  }),
);

export const selectVerifySubdomainState = createSelector(
  [selectMasterSlice],
  masterDataState => ({
    loading: masterDataState.domainVerifyLoading,
    isUnique: masterDataState.domainVerifyResult,
    error: masterDataState.domainVerifyError,
  }),
);

export const selectIssueSourcesList = createSelector(
  [selectMasterSlice],
  state => state.issueSourcesList,
);

export const selectIssueSourcesLastFetch = createSelector(
  [selectMasterSlice],
  state => state.issueSourcesLastFetch,
);
